import { PwaRoute } from '../routing/routes';
import { useAuth } from '../state/AuthProvider';
import { Shell } from './PwaContent';

export function ProtectedMessage({ route }: { route: PwaRoute }) {
  const authContext = useAuth();

  const needsUserLogin = route.visibility === 'user' || route.visibility === 'admin';
  const isSimpleLogin = authContext.auth.authenticated && authContext.auth.auth_type === 'group';

  return (
    <Shell title="Login erforderlich" subtitle={`Der Bereich „${route.label}“ ist geschützt.`}>
      <div className="rounded-2xl border border-red-200 bg-red-50 p-4 text-red-950">
        {!authContext.auth.authenticated && (
          <p>Bitte melde dich an, um diesen Bereich zu verwenden.</p>
        )}

        {isSimpleLogin && needsUserLogin && (
          <p>
            Du bist aktuell nur über den Simple-Gruppenlogin angemeldet. Für diesen Bereich brauchst du einen echten Benutzerlogin.
          </p>
        )}

        {route.visibility === 'admin' && authContext.auth.auth_type === 'user' && !authContext.auth.is_admin && (
          <p>Dein Benutzerkonto hat keine Adminrechte.</p>
        )}
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        <a href="/login/" className="rounded-xl bg-red-700 px-4 py-2 font-bold text-white hover:bg-red-800">
          Zum Login
        </a>
        <a href="/registrieren/" className="rounded-xl border border-red-200 px-4 py-2 font-bold text-red-800 hover:bg-red-50">
          Registrieren
        </a>
      </div>
    </Shell>
  );
}
